// 取引タイプ
export const TRANSACTION_TYPES = {
  INCOME: 'income',
  EXPENSE: 'expense'
};

// 収入カテゴリー
export const INCOME_CATEGORIES = [
  '給料',
  '給付金', 
  '臨時収入',
  '投資'
];

// 支出カテゴリー
export const EXPENSE_CATEGORIES = [
  'サブスクリプション',
  '食費',
  '日用品',
  '交通費',
  '旅費',
  '衣服費',
  '美容費',
  '文房具',
  '趣味費'
];

// 全カテゴリー
export const ALL_CATEGORIES = {
  [TRANSACTION_TYPES.INCOME]: INCOME_CATEGORIES,
  [TRANSACTION_TYPES.EXPENSE]: EXPENSE_CATEGORIES
};

// 取引データの構造
export const createTransaction = (type, category, amount, memo, date) => ({
  type,
  category,
  amount,
  memo,
  date,
  id: null,
  created_at: null,
  updated_at: null
});

// API レスポンスの構造
export const createApiResponse = (success, data = null, error = null) => ({
  success,
  data,
  error
});